import React from 'react'
import { Spacer, Text, View } from 'oio-react'
import { adminUrl } from 'config/constants/urls'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'
import ProductUpdateListItem from '~/components/ProductUpdateListItem'

const AdminWorkspaceAbout = () => (
   <View>
      <ProtoReturnBar
         display="block[a-d] none[e-f]"
         returnLinkName="Admin Workspace"
         returnLinkTo={adminUrl}
      />
      <View display="flex" justifyContent="center">
         <View
            width="100%"
            maxWidth="100%[a-c] 600px[d-f]"
            padding="40px 20px">
            <View
               width="100%"
               display="flex"
               flexFlow="column[a-c] row[d-f]">
               <View paddingRight="30px[b-c] 50px[d-f]">
                  <ProtoHeadingBlock
                     title="Product Updates"
                     description="Latest Communities Product News and Updates"
                  />
               </View>
            </View>
            <Spacer size="3" />
            <View
               width="100%"
               padding="18px"
               marginTop="24px"
               borderRadius="3px"
               backgroundColor="#fff">
               <View paddingBottom="10px">
                  <Text size="2" weight="medium">
                     Release Notes
                  </Text>
               </View>
               <ProductUpdateListItem
                  title="Version 5.10"
                  dateAdded="February 12, 2021"
                  showLatestBadge
                  body={(
                     <>
                        <Text size="1.5" weight="medium" color="#333">
                           User Badges
                        </Text>
                        {'Create Badges that you can assign to users. User badges provide an easy and visually helpful way to identify and distinguish users. For example, you might want to create a Badge so Community users can easily see which users are administrators, moderators, or key staff/team members.'}
                        <br />
                        <br />
                        {'These badges will show up alongside the name of the user they are associated with in most places: Profile, Messages & Discussions, and User Settings.'}
                        <br />
                        <br />
                        <Text size="1.5" weight="medium" color="#333">
                           User Settings
                        </Text>
                        {'We\'ve made some minor but important updates for the user settings in the Admin Workspace. You can filter users by User Badge, and results should load faster, especially in very large communities.'}
                        <br />
                        <br />
                        <Text size="1.5" weight="medium" color="#333">
                           Event Sorting
                        </Text>
                        {'Upcoming Events & Past Events are now sorted the way you would expect them to be!'}
                     </>
                  )}
               />
               <ProductUpdateListItem
                  title="Version 5.9"
                  dateAdded="February 3, 2021"
                  body={(
                     <>
                        <Text size="1.5" weight="medium" color="#333">
                           Direct Messages
                        </Text>
                        {'Users now have the ability to send direct messages! When viewing another users\'s profile, you will now see a "Send Message" button. Direct Messages will appear in the Messages app alongside your Inbox.'}
                        <br />
                        <br />
                        <Text size="1.5" weight="medium" color="#333">
                           Updated Explore Page
                        </Text>
                        {'We\'ve made some minor, but noticeable visual updates to the Explore page. It should feel a little more streamlined and content tiles now show more rich and hopefully useful information.'}
                        <br />
                        <br />
                        <Text size="1.5" weight="medium" color="#333">
                           Report Inappropriate Content
                        </Text>
                        {'Users can now report inappropriate content or spam in discussion messages and direct messages.'}
                     </>
                  )}
               />
               <ProductUpdateListItem
                  title="Version 5.8"
                  dateAdded="January 26, 2021"
                  body={(
                     <>
                        {'This update makes Guest Registration available to Events; and for those who want to add a nice extra layer of security, you can now add Two-Factor Authentication (2FA) to your account.'}
                        <br />
                        <br />
                        <Text size="1.5" weight="medium" color="#333">
                           Event Guest Registration
                        </Text>
                        {'For Open Communities, users can now register and purchase tickets on behalf of other event guests.'}
                        <br />
                        <br />
                        <Text size="1.5" weight="medium" color="#333">
                           Two-Factor Authentication (2FA)
                        </Text>
                        {'All users now have the ability to add Two-Factor Authentication (2FA) to their account. It is an optional but highly recommended security feature that adds an extra layer of protection. You can access this feature by going to your profile and accessing your profile and account settings.'}
                     </>
                  )}
               />
               <ProductUpdateListItem
                  title="Version 5.7"
                  dateAdded="January 21, 2021"
                  body={(
                     <>
                        {'It\'s a new year, and it\'s time for some exciting new changes!'}
                        <br />
                        <br />
                        <Text size="1.5" weight="medium" color="#333">
                           Online (Virtual) Events
                        </Text>
                        {'Much has changed for all of us in the past year, including how many of you are now hosting your events online!'}
                        <br />
                        <br />
                        {'Admins now have the ability to create Events that are online-only. Events that are "online-only" will now be labeled with a special badge and show their location as such.'}
                        <br />
                        <br />
                        {'Events that are online-only (virtual) will also have the ability to embed a live video stream from Youtube. When you do so, a new button called "Play Stream" will appear on your Event page.'}
                        <br />
                        <br />
                        <Text size="1.5" weight="medium" color="#333">
                           Updated Admin Workspace
                        </Text>
                        {'We\'ve re-organized and simplified the Admin Workspace to streamline getting around to different settings more quickly and efficiently.'}
                        <br />
                        <br />
                        {'We also added this new "Product Updates" section to the Admin Workspace to keep you all better informed about the changes and updates that are being made.'}
                     </>
                  )}
               />
            </View>
         </View>
      </View>
   </View>
)

export default AdminWorkspaceAbout
